<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 16px;padding: 10px;" v-if="this.tipoFormulario == 'CADASTRO'" >
              <span class="login-title">
                <img :src="igreja.logoUrl" width="230px">
              </span>
              <v-card-text style="padding: 0px" v-if="!dialogoTipoMembro">
                <v-container fluid grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha seus dados:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="membro.nome" label="NOME COMPLETO*" single-line outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light label="CPF*" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="membro.cpf" @change="consultaCPF"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field type="tel" light v-model="membro.dataNascimento" label="DATA DE NASCIMENTO*" single-line outlined color="#00695C" required v-mask="'##/##/####'" dense hide-details :error-messages="errors.collect('dateOfBirth')" return-masked-value mask="##/##/####" data-vv-name="dateOfBirth"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-select outlined dense v-model="membro.sexo" :items="sexo" hide-details item-text="titulo" item-value="id" color="#00695C" label="SEXO*"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light label="WHATSAPP COM DDD*" color="#00695C" type="tel" outlined hide-details v-mask="'(##) #####-####'" dense required v-model="membro.telefone"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3 v-if="membro.tipo != 'VISITANTE'">
                      <v-select outlined dense v-model="membro.estadoCivil" :items="estadoCivil" hide-details item-text="titulo" item-value="id" color="#00695C" label="ESTADO CIVIL*"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="membro.tipo != 'VISITANTE'">
                      <v-select outlined dense v-model="membro.batizado" :items="condicoes" hide-details item-text="text" item-value="value" color="#00695C" label="VOCÊ É BATIZADO?*"></v-select>
                    </v-flex>
                    <v-flex v-if="membro.batizado || membro.tipo != 'VISITANTE'" xs12 sm12 lg4>
                      <v-select outlined dense v-model="membro.batismoLiberdade" :items="condicoes" hide-details item-text="text" item-value="value" color="#00695C" label="FOI BATIZADO NA IGREJA BATISTA DA LIBERDADE?*"></v-select>
                    </v-flex>
                    <v-flex v-if="membro.batismoLiberdade == false || membro.tipo != 'VISITANTE'" xs12 sm12 lg4>
                      <v-text-field outlined dense v-model="membro.igrejaBatismo" hide-details color="#00695C" label="INFORME O NOME DA IGREJA*"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="membro.tipo != 'VISITANTE'">
                      <v-select outlined dense v-model="membro.tipoIntegracao" :items="tipoIntegracao" hide-details item-text="titulo" item-value="id" color="#00695C" label="TIPO DE INTEGRAÇÃO*"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="membro.tipo != 'VISITANTE'">
                      <v-text-field type="tel" light v-model="membro.dataIntegracao" label="DATA DE INTEGRAÇÃO*" single-line outlined color="#00695C" required v-mask="'##/##/####'" dense hide-details :error-messages="errors.collect('dateOfBirth')" data-vv-name="dateOfBirth"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6 v-if="membro.tipo != 'VISITANTE'">
                      <v-select outlined dense v-model="redeSelecionada" :items="redes" hide-details item-text="nome" item-value="id" color="#00695C" label="REDE" @input="carregaCelulas"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg6 v-if="membro.tipo != 'VISITANTE'">
                      <v-select outlined dense :disabled="redeSelecionada == ''" v-model="membro.celulaId" :items="celulas" hide-details item-text="nome" item-value="id" color="#00695C" label="CÉLULA"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-checkbox v-model="membro.aceiteLgpd" style="margin-top: 10px">
                        <template v-slot:label>
                          <div>
                            Concordo com as <a target="_blank" href="https://2eea8b7d-a702-46f5-8be7-466aa412f79b.usrfiles.com/ugd/2eea8b_6acd8479401b41da80bfe3bbf2a0d37d.pdf" @click.stop>políticas de privacidade e tratamento de dados pessoais</a>
                          </div>
                        </template>
                      </v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg6>
                      <v-btn dark depressed block rounded color="#00695C" large @click="criaMembro">Confirmar Cadastro</v-btn>
                    </v-flex> 
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
            <v-card class="login" flat style="border-radius: 16px; padding: 10px;" v-if="this.tipoFormulario == 'BATISMO'">
              <span class="login-title">
                <img :src="igreja.logoUrl" width="230px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg12>
                      <h3 style="margin-bottom: 0px; text-align: center; font-family:'Fraunces',serif; color:#00253E;"> Olá, {{ nomeMembro }}!<br>Por favor, informe os dados abaixo:</h3>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-select outlined dense v-model="informacoesBatismo.batizado" :items="condicoes" hide-details item-text="text" item-value="value" color="#00695C" label="VOCÊ É BATIZADO?*"></v-select>
                    </v-flex>
                    <v-flex v-if="informacoesBatismo.batizado" xs12 sm12 lg4>
                      <v-select outlined dense v-model="informacoesBatismo.batismoLiberdade" :items="condicoes" hide-details item-text="text" item-value="value" color="#00695C" label="FOI BATIZADO NA IGREJA BATISTA DA LIBERDADE?*"></v-select>
                    </v-flex>
                    <v-flex v-if="informacoesBatismo.batismoLiberdade == false" xs12 sm12 lg4>
                      <v-text-field outlined dense v-model="informacoesBatismo.igrejaBatismo" hide-details color="#00695C" label="INFORME O NOME DA IGREJA*"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg6>
                     <v-btn dark depressed block rounded color="#00695C" large @click="atualizaMembro">Enviar</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoTemplusIntelite.png" width="300px">
          </a>
        </div>
        <!-- FIM INSCRIÇÃO -->
        <!-- MENSAGEM FINAL -->
        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-card>
            <v-card-title>Informação</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="success" size="100">check_circle</v-icon>
                    <p class="texto" style="color:#00695C">Cadastro efetuado com sucesso!</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>capturaTipo
              <v-btn text color="primary" @click="closeDialog">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- FIM MENSAGEM FINAL -->

        <v-dialog v-model="dialogoTipoMembro" persistent max-width="500px">
          <v-card>
            <v-card-title>Selecione uma opção</v-card-title>
            <v-card-text>
              <v-row dense>
                <!-- <v-col cols="12" xs="12" sm="12" lg="12">
                  <v-btn block @click="capturaTipo('MEMBRO')" :color="membro.tipo == 'MEMBRO' ? 'success' : ''" :outlined="membro.tipo != 'MEMBRO'">Faço parte da Liberdade</v-btn>
                </v-col> -->
                <v-col cols="12" xs="12" sm="12" lg="12">
                  <v-btn block @click="capturaTipo('VISITANTE')" :color="membro.tipo == 'VISITANTE' ? 'success' : ''" :outlined="membro.tipo != 'VISITANTE'">Sou visitante</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import CpfValidate from '../../componentes/validators/rules/cpf'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import axios from 'axios'
export default {
  components: { Snackbar, Loading, },
  name: 'Auth',
  computed: mapState({
    usuarioLogado: state => state.isMenuVisible,
    nomeMembro() {
      if (this.membroCarregado.nome) return this.membroCarregado.nome.split(' ')[0]
    }
  }),
  data: function () {
    return {
      idIgreja: '6390de5538a3bc18300a2022',
      user: {},
      eventoSelecionado: '',
      membro: {
        nome: '',
        cpf: '',
        email: '',
        dataNascimento: '',
        estadoCivil: '',
        sexo: '',
        telefone: '',
        tipo: '',
        dataIntegracao: '',
        tipoIntegracao: '',
        aceiteLgpd: null,
        celulaId: '',
        igrejaId: '',
        batizado: null,
        igrejaBatismo: '',
        batismoLiberdade: null,
      },
      informacoesBatismo: {
        batizado: null,
        igrejaBatismo: '',
        batismoLiberdade: null,
      },
      dialog: false,
      redeSelecionada: '',
      sexo: ['MASCULINO', 'FEMININO'],
      qualificacoes: ['APOIO', 'VIGILANTE BÁSICO', 'VIGILANTE DE GRANDES EVENTOS'],
      estadoCivil: ['SOLTEIRO(A)', 'CASADO(A)', 'VIÚVO(A)', 'DIVORCIADO(A)', 'RELAÇÃO ESTÁVEL'],
      tipoMembro: ['CONGREGADO', 'MEMBRO'],
      tipoIntegracao: ['ATRAVÉS DE BATISMO', 'VENHO DE OUTRA IGREJA'],
      condicoes: [
        { value: true, text: 'SIM'},
        { value: false, text: 'NÂO'},
      ],
      redes: [],
      celulas: [],
      isLoading: false,
      fullPage: true,
      jaExiste: false,
      codigoExistente: '',
      msgResultado: '',
      codigoGerado: '',
      igreja: {},
      tipoFormulario: '',
      membroCarregado: [],
      dialogoTipoMembro: true,
      dictionary: {          
        custom: {
          dateOfBirth: {
            required: () => 'Informe a data de nascimento',
            date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
          },
        }
      },
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Insira um e-mail válido (apenas minúsculas)'
        },
      },
    }
  },
  
  mounted: function () {
    this.pegaParametrosUrl()
    this.carregaDados()
  },
  
  watch: {
    'membro.batismoLiberdade'(val) {
      if (this.membro.batizado && val == true) { 
        this.membro.tipo = 'MEMBRO'
      } else {
        this.membro.tipo = 'CONGREGADO'
      }
    },

    'membro.batizado'(val) {
      if (val == false) {
        this.membro.tipo = 'CONGREGADO'
      }
    }
  },

  methods: {
    async carregaDados() {
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.idIgreja } })
        if (response.data) {
          this.igreja = response.data
        }
      } catch (error) {
        this.$refs.chamaSnackbar.snack('#FF5252', 'Erro ao carregar dados da igreja.', 'ERRO')
      } finally {
        this.isLoading = false
      }
      this.carregaRedes()
    },

    async carregaRedes() {
      await axios.post(baseApiUrl + 'Redes/listarPublicasPorTipo', {
        igrejaId: this.igreja.id,
        tipo: 'ADULTO',
      }).then(response => {
        if (response.data) {
          this.redes = response.data
        }
      })
    },

    async carregaCelulas() {
      await axios.post(baseApiUrl + 'Celulas/listarPorRedePublico', null, { params: { redeId: this.redeSelecionada } })
      .then(response => {
        if (response.data) {
          this.celulas = response.data
        }
      })
    },

    async consultaCPF() {
      var vm = this;
      this.isLoading = true
      await axios.post(baseApiUrl + 'Membros/verificaExistenciaCpfPublico', null, { params: { cpf: this.membro.cpf } })
      .then(response => {
        if (response.data) {
          if (response.data.existe === true || response.data.count == 1) { 
            vm.$refs.chamaSnackbar.snack("#F9A825","Já existe uma inscrição para o CPF informado. Entre em contato com a administração!","ATENÇÃO")
          }
          this.isLoading = false
        }
      })
    },

    async inscricaoVigilante() {
      var vm = this;
      if ((this.vigilante.nome == '') || (!CpfValidate(this.vigilante.cpf)) || (this.vigilante.sexo == '') || (this.vigilante.telefone == '') || (this.vigilante.dataNascimento == '') || (this.vigilante.qualificacao == '')) {
        vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os campos!","ATENÇÃO")
      } else {
        try {
          this.vigilante.nome = this.vigilante.nome.toUpperCase()
          this.isLoading = true
          await axios.post(`${baseApiUrl}Vigilantes/salvaVigilante`, this.vigilante).then(res => {
            if (res.data) {
              this.codigoGerado = res.data.codigo
              this.msgResultado = 'Cadastro realizado com sucesso!'
              this.dialog = true
              this.isLoading = false
            }
          })
        } catch (error) {
          this.isLoading = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar inscrição. Tente novamente.", "DESCULPE")
        }
      }
    },

    async criaMembro() {
      var vm = this;
      let camposEmBranco

      if (this.membro.tipo == 'VISITANTE') {
        if (!this.membro.nome || !this.membro.cpf || !CpfValidate(this.membro.cpf) || !this.membro.dataNascimento || !this.membro.sexo || !this.membro.telefone || !this.membro.aceiteLgpd) {
          camposEmBranco = true
        } else {
          camposEmBranco = false
        }
      } else {
        if (!this.membro.nome || !this.membro.cpf || !CpfValidate(this.membro.cpf) || !this.membro.dataNascimento || !this.membro.sexo || !this.membro.telefone || !this.membro.estadoCivil || !this.membro.tipo || !this.membro.tipoIntegracao || !this.membro.dataIntegracao || !this.membro.aceiteLgpd  || !this.redeSelecionada || !this.membro.celulaId )   { 
          camposEmBranco = true
        } else {
          camposEmBranco = false
        }
      }

      if (camposEmBranco) {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente!", "ATENÇÃO")
      } else {
        this.isLoading = true
        if (this.membro.tipo != 'VISITANTE') {
          const [day, month, year] = this.membro.dataIntegracao.split('/')
          this.membro.dataIntegracao = year + '-' + month + '-' + day + 'T00:00:00.000Z'
        } else {
          this.membro.dataIntegracao = moment().format('YYYY-MM-DD') + 'T00:00:00.000Z'
        }
        this.membro.igrejaId = this.igreja.id
        await axios.post(baseApiUrl + 'Membros/salvarPublico', this.membro)
        .then(response => {
          if (response.data) {
            this.dialog = true
            this.isLoading = false
            if (this.membro.tipo == 'VISITANTE') {
              this.$router.push({ path: '/liberdadeeb' })
            }
          }
        }).catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar cadastro, verifique os dados informados e tente novamente", "DESCULPE")
        })
      }
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    closeDialog() {
      this.dialog = false
      this.vigilante = Object.assign({}, this.vigilanteDefault)
      this.$validator.reset()
      window.location.reload()
    },

    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.fim;
      const dataB = b.fim;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    transformaData(data, formato) {
      let date = moment(data).format(formato);
      return date
    },

    async pegaParametrosUrl() {
      this.tipoFormulario = ''
      this.isLoading = true
      var params = window.location.search.substring(1).split('&')
      if (params[0] != '') {
        var paramArray = {}
        for (let i = 0; i < params.length; i++) {
          var param = params[i].split('=')
          paramArray[param[0]] = param[1]
        }
        if (paramArray['id']) {
          this.tipoFormulario = 'BATISMO'
          this.pegaMembro(paramArray['id'])
        } else {
          this.tipoFormulario = 'CADASTRO'
        }
      } else{
        this.tipoFormulario = 'CADASTRO'
      }
    },

    async pegaMembro(id) {
      await axios.post(baseApiUrl + 'Membros/buscarBatismoPublico', null, { params: { membroId: id } })
      .then(response => {
        if (response.data) {
          this.membroCarregado = response.data
          if (this.membroCarregado.batizado && this.membroCarregado.batismoLiberdade && this.membroCarregado.igrejaBatismo) {
            this.informacoesBatismo.batizado = this.membroCarregado.batizado
            this.informacoesBatismo.batismoLiberdade = this.membroCarregado.batismoLiberdade
            this.informacoesBatismo.igrejaBatismo = this.membroCarregado.igrejaBatismo
          }
        }
      })
    },

    async atualizaMembro() {
      this.isLoading = true
      await axios.post(baseApiUrl + 'Membros/atualizarBatismoPublico', this.informacoesBatismo, { params: { membroId: this.membroCarregado.id } })
      .then(response => {
        if (response.data) {
          this.isLoading = false
          var vm = this
          vm.$refs.chamaSnackbar.snack("#0288D1", "Informações salvas com sucesso!", "INFORMAÇÃO")
        }
      })
    },

    capturaTipo(tipo) {
      this.membro.tipo = tipo
      this.dialogoTipoMembro = false
    },
  }
}
</script>

<style scoped>
/* LOGIN */

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 16px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 15px;
  padding-bottom: 15px;
  box-shadow: 0 30px 60px rgba(0, 37, 62, .2) !important;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center
}

@import '../../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css'
</style>
